// extracted by mini-css-extract-plugin
module.exports = {"contentMT":"Main_contentMT__35B-v"};